import '../../index.css'
import './SocialLinks.css';

// Component expects an array of links: [{ icon: 'fab fa-github', url: 'https://...' }]
// Style props default to standard values if not provided
export default function SocialLinks({ 
  links = [], 
  iconSize = '3vmax', 
  hoverColor = 'clr-dark-blue',
  maxWidth = '100%',
  class_Name = "clr-dark-blue visited-dark-blue",
  iconColor = 'clr-dark-blue', 
  iconVisitedClr = "visited-dark-blue"
}) {
  const componentStyles = {
    '--icon-size': iconSize,
    '--icon-color': iconColor,
    '--hover-color': hoverColor,

    maxWidth: maxWidth  
  };

    const SocialLink = ({link, index, class_Name}) =>{
    return(

      <div className={`flex-column-centered`}>
            <a 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className={`social-link-item ${iconColor}`}
                aria-label={link.label || 'Social Link'}
            >
                <i className={`${link.icon}  ${iconVisitedClr}`}></i>
            </a>
            {/* <StandardText class_Name={`${class_Name} font-size-2`}>{link.label}</StandardText> */}
        </div>
    )
  }


  return (
    <div className={`social-links-container ${class_Name} margin-bottom-5`} style={componentStyles}>
      {links.map((link, index) => (
        <SocialLink key={index} link={link} index={index} class_Name={class_Name} iconColor={`${iconColor}`}/>
      ))}
    </div>
  );
}
